@if (isExternal) {
  <a
    class="textLink"
    [ngClass]="'text-' + color"
    [href]="routerLink"
    target="_blank"
    rel="noopener noreferrer"
    >
    {{ text }}
  </a>
} @else {
  <a
    class="textLink"
    [ngClass]="['text-' + color, 'hover:text-' + color + '-hover']"
    [routerLink]="routerLink"
    >
    {{ text }}
  </a>
}

